import store from '@/store';

const role = {
  Administracion: 'Administracion',
  Empresa_Gas: 'AP_BDDI_Empresa_Gas',
  Empresa_Electricidad: 'AP_BDDI_Empresa_Electricidad',
  Empresa_Petroleo: 'AP_BDDI_Empresa_Petroleo'
};

function userIsAuthenticated() {
  return store.getters.userAuthenticated;
}

function userAuthenticatedHasRole(role) {
  if (!role || isAdmin()) return true;

  if (role instanceof Array || Object.prototype.toString.call(role) === '[object Array]') {
    return hasAnyRole(role);
  }

  return store.getters.roles.filter(item => item === role).length > 0;
}

function hasAnyRole(roles) {
  if (isAdmin()) return true;

  return (
    store.getters.roles.filter(item1 => roles.filter(item2 => item2 === item1).length > 0).length >
    0
  );
}

function isAdmin() {
  return store.getters.roles.filter(item => item === role.Administracion).length > 0;
}

const auth = {
  userIsAuthenticated,
  userAuthenticatedHasRole
};

const Auth = {
  install(Vue) {
    Vue.prototype.$auth = auth;
  }
};

export { auth };

export default Auth;
